<template>
  <div id="new-account">
    <div class="container">
      <div class="col-md-12" style=" height: 90vh;overflow: hidden; display: flex; flex-direction: column; align-items: center; justify-content: center">
        <h1>
          {{ $t("pages.newAccount.welcome") }},
          <span style="color: #03658c">{{ $store.getters.currentUser.firstName }}</span>
        </h1>
        <p>{{ $t("pages.newAccount.cantCreate") }}</p>
        <div style="text-align: center; margin-top: 25px;">
          <label style="font-size: 20px; color: #03658c">{{ $t("pages.newAccount.createFirstEvenet") }}</label>
          <div style="display: flex;">
            <el-input v-model="form.title" style="width: 250px" :placeholder="$t('pages.newAccount.placeholderTypeEvent')"></el-input>
            <el-button type="primary" :loading="loading" @click="createEvent">{{ $t("pages.newAccount.create") }}</el-button>
          </div>
        </div>

        <div style="text-align: center; margin-top: 25px;">
          <!-- <label style="font-size: 20px; color: #333; display: block">
            Mevcut Krediniz
            <strong>{{ $store.state.user.user.availableCredit }}</strong>
          </label> -->
          <label style="font-size: 20px; color: #03658c">{{ $t("pages.newAccount.activateCouponCode") }}</label>
          <div style="display: flex;">
            <el-input v-model="form.code" style="width: 250px" :placeholder="$t('pages.newAccount.placeholderTypeCoupon')"></el-input>
            <el-button type="primary" @click="applyCouponCode">{{ $t("pages.newAccount.activate") }}</el-button>
          </div>
        </div>

        <!-- <div style="margin-top: 25px">
          <el-button
            @click="$root.$emit('openCredits')"
            style="background: none; border-color: #03658c; font-size: 20px;"
          >Kredi Paketlerine Gözat</el-button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "NewAccount",
  metaInfo: {
    title: "Welcome"
  },
  data() {
    return {
      loading: false,
      form: {
        title: null,
        code: null
      }
    };
  },
  methods: {
    applyCouponCode() {
      axios.post("payment/applycouponcode", { code: this.form.code }).then(res => {
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          this.$store.dispatch("getUser");
          this.code = null;
        }
      });
    },
    switchEvent(id) {
      axios.post("login/switchevent", { id }).then(res => {
        axios.defaults.headers["Authorization"] = "Bearer " + res.data.data.token;
        this.$store.state.user.token = res.data.data.token;
        localStorage.setItem("token", res.data.data.token);
        window.location.href = "/";
      });
    },
    createEvent() {
      this.loading = true;

      axios.post("event/create", { title: this.form.title }).then(res => {
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
          this.loading = false;
        } else {
          this.$message.success(res.data.alert.message);
          setTimeout(() => {
            this.switchEvent(res.data.data);
          }, 2000);
        }
      });
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: bold;
  margin: 0;
  font-size: 45px;
}

p {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/NewAccount.vue